import { TextField } from "@mui/material";

function GenericTextField(props) {
  return (
    <TextField
      {...props}
      InputLabelProps={{
        shrink: true,
      }}
      fullWidth
      size="small"
    />
  );
}

export default GenericTextField;
